import React from 'react';
import { Row, Col } from 'reactstrap';
import EventCard from './EventCard';

const EventGroup = ({ title, events, gridSize, onEdit, onCheckIn, showDate = false }) => (
    <>
        <Col xs={12} className='mt-3 mb-2'>
            <h5 className='text-success fw-bold'>{title}</h5>
        </Col>
        <Row>
            {events.map(event => (
                <Col xs={12} lg={gridSize || 12} key={event.id} className='d-flex'>
                    <EventCard
                        event={event}
                        onEdit={() => onEdit(event.id)}
                        onCheckIn={() => onCheckIn(event)}
                        showDate={showDate}
                    />
                </Col>
            ))}
        </Row>
    </>
);

export default EventGroup;
